import {Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {Select} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {Observable, Subscription} from 'rxjs';
import {UserModel} from '../services/user/user.model';
import {map, tap} from 'rxjs/operators';

@Directive({
  selector: '[appAdminOnlyDirective]'
})
export class AdminOnlyDirective implements OnInit, OnDestroy {
  @Select(AppState.currentUser$) currentUser$: Observable<UserModel>;

  private subscription: Subscription;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) { }


  ngOnInit(): void {
    this.subscription = this.currentUser$.pipe(
      map(user => user && user.admin != null ? user.admin : false)
    ).subscribe(isAdmin => {
      if (isAdmin) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
